module.exports = __webpack_public_path__ + "fonts/GalanoGrotesque-Bold.645344c.woff";